import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { trackEvent as track } from '../utils/analytics';
import { TrustHero } from '../components/trust/TrustHero';
import { TrustChallenge } from '../components/trust/TrustChallenge';
import { TrustSolution } from '../components/trust/TrustSolution';
import { TrustFinalCTA } from '../components/trust/TrustFinalCTA';
export function Trust() {
  useEffect(() => {
    track('Page Viewed', {
      page: 'Trust'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8715" data-mp="39rh89by7nqc8">
      <Header data-id="element-8716" data-mp="34zz9mujnu1uf" />
      <main className="pt-[120px]" data-id="element-8717" data-mp="34zh1p0nmxz6o">
        <TrustHero data-id="element-8718" data-mp="34yfs70m9pkr2" />
        <TrustChallenge data-id="element-8719" data-mp="34xw9vispguci" />
        <TrustSolution data-id="element-8720" data-mp="301pcwfiaet6p" />
        <TrustFinalCTA data-id="element-8721" data-mp="3004kavfj9kbh" />
      </main>
      <Footer data-id="element-8722" data-mp="2zz34kdnko9nf" />
    </div>;
}